// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__wxSAB","messages":"Chat_messages__23d_6","dateDivider":"Chat_dateDivider__oNAbT"};